import * as React from 'react';
// import MaskedInput from 'react-text-mask';
import { GridSpacing } from '@material-ui/core/Grid';
import { TextField, FilledTextFieldProps, InputAdornment } from '@material-ui/core';

export interface Props extends Partial<FilledTextFieldProps> {
  inputStyle?: any;
  errorMessage?: string | boolean | undefined;
  mask?: any;
  spacing?: GridSpacing;
  title?: string;
  value?: any;
  helperText?: string;
  endAdornment?: React.ReactNode;
  startAdornment?: React.ReactNode | string;
}

const TextInput: React.FC<Props> = (props) => {
  const {
    endAdornment,
    errorMessage,
    error,
    helperText,
    inputStyle,
    mask,
    title,
    spacing,
    startAdornment,
    variant,
    children,
    ...restOfProps
  } = props;

  // TODO: add later
  // const maskedInputProps = mask && !!mask.length ? { guide: false, mask } : {};
  // const inputComponent = mask && !!mask.length ? MaskedInput : undefined;

  const getEndAdornment = () =>
    endAdornment ? (
      <InputAdornment position="end">{endAdornment}</InputAdornment>
    ) : (
      restOfProps.InputProps?.endAdornment
    );
  const getStartAdornment = () =>
    startAdornment ? (
      <InputAdornment position="start">{startAdornment}</InputAdornment>
    ) : (
      restOfProps.InputProps?.startAdornment
    );

  return (
    <TextField
      {...restOfProps}
      id={title}
      label={title}
      helperText={errorMessage || helperText || ' '}
      fullWidth
      margin="normal"
      InputProps={{
        ...restOfProps.InputProps,
        disableUnderline: true,
        endAdornment: getEndAdornment(),
        startAdornment: getStartAdornment(),
      }}
      InputLabelProps={{
        shrink: true,
      }}
      variant="filled"
      error={!!errorMessage}
    >
      {children}
    </TextField>
  );
};

export default TextInput;
